module.exports = "/_next/static/images/dm-3a68c10ddff99e1ac8801caeedeb9527.svg";